// extracted by mini-css-extract-plugin
export var next = "commentsPagination-module--next--57c3a";
export var prev = "commentsPagination-module--prev--576b5";
export var wrapper = "commentsPagination-module--wrapper--5bfe3";